module.exports = __webpack_public_path__ + "static/media/auth-layer.45e13f4f.png";